module.exports = __webpack_public_path__ + "static/media/map-icon.a6c308fd.svg";